module.exports = __webpack_public_path__ + "images/cov-01-faq-desktop.png";